/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthVarianceRouteImport } from './routes/_auth.variance'
import { Route as AuthUsersRouteImport } from './routes/_auth.users'
import { Route as AuthScannerRouteImport } from './routes/_auth.scanner'
import { Route as AuthInspectorRouteImport } from './routes/_auth.inspector'
import { Route as AuthHomeRouteImport } from './routes/_auth.home'
import { Route as AuthDashboardRouteImport } from './routes/_auth.dashboard'
import { Route as AuthCrossoverRouteImport } from './routes/_auth.crossover'
import { Route as AuthBacktestRouteImport } from './routes/_auth.backtest'
import { Route as AuthAnalysisRouteImport } from './routes/_auth.analysis'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVarianceRoute = AuthVarianceRouteImport.update({
  id: '/variance',
  path: '/variance',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersRoute = AuthUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScannerRoute = AuthScannerRouteImport.update({
  id: '/scanner',
  path: '/scanner',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInspectorRoute = AuthInspectorRouteImport.update({
  id: '/inspector',
  path: '/inspector',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHomeRoute = AuthHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCrossoverRoute = AuthCrossoverRouteImport.update({
  id: '/crossover',
  path: '/crossover',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBacktestRoute = AuthBacktestRouteImport.update({
  id: '/backtest',
  path: '/backtest',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAnalysisRoute = AuthAnalysisRouteImport.update({
  id: '/analysis',
  path: '/analysis',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/analysis': typeof AuthAnalysisRoute
  '/backtest': typeof AuthBacktestRoute
  '/crossover': typeof AuthCrossoverRoute
  '/dashboard': typeof AuthDashboardRoute
  '/home': typeof AuthHomeRoute
  '/inspector': typeof AuthInspectorRoute
  '/scanner': typeof AuthScannerRoute
  '/users': typeof AuthUsersRoute
  '/variance': typeof AuthVarianceRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/analysis': typeof AuthAnalysisRoute
  '/backtest': typeof AuthBacktestRoute
  '/crossover': typeof AuthCrossoverRoute
  '/dashboard': typeof AuthDashboardRoute
  '/home': typeof AuthHomeRoute
  '/inspector': typeof AuthInspectorRoute
  '/scanner': typeof AuthScannerRoute
  '/users': typeof AuthUsersRoute
  '/variance': typeof AuthVarianceRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/analysis': typeof AuthAnalysisRoute
  '/_auth/backtest': typeof AuthBacktestRoute
  '/_auth/crossover': typeof AuthCrossoverRoute
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/home': typeof AuthHomeRoute
  '/_auth/inspector': typeof AuthInspectorRoute
  '/_auth/scanner': typeof AuthScannerRoute
  '/_auth/users': typeof AuthUsersRoute
  '/_auth/variance': typeof AuthVarianceRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/analysis'
    | '/backtest'
    | '/crossover'
    | '/dashboard'
    | '/home'
    | '/inspector'
    | '/scanner'
    | '/users'
    | '/variance'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/analysis'
    | '/backtest'
    | '/crossover'
    | '/dashboard'
    | '/home'
    | '/inspector'
    | '/scanner'
    | '/users'
    | '/variance'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/analysis'
    | '/_auth/backtest'
    | '/_auth/crossover'
    | '/_auth/dashboard'
    | '/_auth/home'
    | '/_auth/inspector'
    | '/_auth/scanner'
    | '/_auth/users'
    | '/_auth/variance'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/variance': {
      id: '/_auth/variance'
      path: '/variance'
      fullPath: '/variance'
      preLoaderRoute: typeof AuthVarianceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users': {
      id: '/_auth/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthUsersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/scanner': {
      id: '/_auth/scanner'
      path: '/scanner'
      fullPath: '/scanner'
      preLoaderRoute: typeof AuthScannerRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/inspector': {
      id: '/_auth/inspector'
      path: '/inspector'
      fullPath: '/inspector'
      preLoaderRoute: typeof AuthInspectorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/home': {
      id: '/_auth/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthHomeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/crossover': {
      id: '/_auth/crossover'
      path: '/crossover'
      fullPath: '/crossover'
      preLoaderRoute: typeof AuthCrossoverRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/backtest': {
      id: '/_auth/backtest'
      path: '/backtest'
      fullPath: '/backtest'
      preLoaderRoute: typeof AuthBacktestRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/analysis': {
      id: '/_auth/analysis'
      path: '/analysis'
      fullPath: '/analysis'
      preLoaderRoute: typeof AuthAnalysisRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthAnalysisRoute: typeof AuthAnalysisRoute
  AuthBacktestRoute: typeof AuthBacktestRoute
  AuthCrossoverRoute: typeof AuthCrossoverRoute
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthHomeRoute: typeof AuthHomeRoute
  AuthInspectorRoute: typeof AuthInspectorRoute
  AuthScannerRoute: typeof AuthScannerRoute
  AuthUsersRoute: typeof AuthUsersRoute
  AuthVarianceRoute: typeof AuthVarianceRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAnalysisRoute: AuthAnalysisRoute,
  AuthBacktestRoute: AuthBacktestRoute,
  AuthCrossoverRoute: AuthCrossoverRoute,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthHomeRoute: AuthHomeRoute,
  AuthInspectorRoute: AuthInspectorRoute,
  AuthScannerRoute: AuthScannerRoute,
  AuthUsersRoute: AuthUsersRoute,
  AuthVarianceRoute: AuthVarianceRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
